import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { colors, fonts } from "../../styles";
import Grid from "@material-ui/core/Grid";
import { ethers } from "ethers";
import { useTranslation } from "react-i18next";

const SBannerWrapper = styled.div`
  width: 94%;
  max-width: 700px;
  // background: linear-gradient(254.71deg, rgba(${colors.gradDark}) 1.92%, rgba(${colors.gradLight}) 101.29%);
  background: #1b2150;
  // background: #0C2340;
  border: 2px solid rgba(${colors.border});
  margin: 0 auto 10px;
  border-radius: 25px;
  padding: 1.5em;
  backdrop-filter: blur(4px);
  transition: all 0.2s ease-in-out;
  display: flex;
  flex-direction: column;
  align-items: center;
  z-index: 10 !important;
  @media (max-width: 768px) {
    padding: 1em;
  }
`;

const CardTitle = styled.h3`
  color: rgb(${colors.white});
  font-weight: ${fonts.weight.medium};
  font-size: 32px;
  margin: 10px 20px;
  font-family: "Montserrat-SemiBold";
`;

const InputTitle = styled.h5`
  color: rgb(${colors.white});
  font-weight: ${fonts.weight.normal};
  // font-family: "NexaDemo-Light";
  font-size: ${fonts.size.h6};
  text-align: center;
  @media (max-width: 960px) {
    text-align: left;
    margin-left: 0;
  }
`;

const UnderLineTextField = styled.input`
  width: 100%;
  margin: 0 auto;
  color: rgb(${colors.white});
  font-size: ${fonts.size.h5};
  font-weight: ${fonts.weight.normal};
  // font-family: "NexaDemo-Light";
  margin-top: 8px;
  border: 0;
  border-radius: 0;
  outline: 0;
  background: transparent;
  border-bottom: 1px solid rgb(${colors.white});
`;

const OutlineButton = styled.button`
  max-width: 272px;
  width: 100%;
  font-size: 18px;
  // font-family: "NexaDemo-Light";
  height: 54px;
  border-radius: 20px;
  border: 1px solid rgb(${colors.fontColor});
  color: rgb(${colors.fontColor});
  // background: linear-gradient(180deg, rgba(16,23,65,1) 0%, rgba(12,35,64,1) 100%);
  background: transparent;
  margin: 1em 0;
  transition: all 0.2s ease-out;
  text-align: center;

  @media (max-width: 550px) {
    width: 90%;
    font-size: 16px;
  }
  &:hover {
    box-shadow: 0 4px 8px 0 rgba(${colors.border});
    cursor: pointer;
    color: rgb(${colors.main});
    background: rgb(${colors.fontColor});
  }
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  position: relative;
  justify-content: center;
`;

interface Props {
  onPrivateSend?: (
    amount: string,
    receiver: string,
    salt: string,
    isGlass: boolean
  ) => void;
  onGaslessSend?: (amount: string, receiver: string, salt: string) => void;
  getEarnText?: (address: string) => Promise<string>;
}

const SaleInfo = (props: Props) => {
  const [minutes, setMinutes] = useState(59);
  const [showDot, setShowDot] = useState(true);
  const [amount, setAmount] = React.useState("");
  const [address, setAddress] = React.useState("");
  const [salt, setSalt] = React.useState("");
  const { t } = useTranslation();
  // const [earnText, setEarnText] = React.useState("");

  useEffect(() => {
    if (minutes > 0) {
      setTimeout(() => setMinutes(minutes - 1), 60000);
      setTimeout(() => setShowDot(!showDot), 500);
    } else {
      setMinutes(0);
    }
  }, [minutes, showDot]);

  const onChangeAmount = (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      if (e.currentTarget.value === "") {
        setAmount(e.currentTarget.value);
      } else if (!isNaN(Number(e.currentTarget.value))) {
        setAmount(e.currentTarget.value);
      }
    } catch (error) {}
  };

  const onChangeAddress = (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      setAddress(e.currentTarget.value);
      if (ethers.utils.isAddress(e.currentTarget.value)) {
        // onGetEearnestArrow(e.currentTarget.value);
      }
    } catch (error) {}
  };

  const onChangeSalt = (e: React.ChangeEvent<HTMLInputElement>) => {
    try {
      if (e.currentTarget.value === "") {
        setSalt(e.currentTarget.value);
      } else if (!isNaN(Number(e.currentTarget.value))) {
        setSalt(e.currentTarget.value);
      }
    } catch (error) {}
  };

  // const onGetEearnestArrow = async (add: string) => {
  //   let msg = await props.getEarnText(add);
  //   console.log("EearnestArrow", msg);
  //   setEarnText(msg);
  // };

  return (
    <div>
      {/* <SaleTitle>{earnText}</SaleTitle> */}
      <SBannerWrapper>
        <Row>
          <CardTitle>{t("BV3AAcquisition")}</CardTitle>
          {/* <QuestionMark>?</QuestionMark>
        <Description className="question">
          Gasless transactions use BUCC instead of ETH to pay for the transaction fees. This is primarily used for sending BUCC from a freshly generated address that holds no ETH, or also is spending ETH is not desired and BUCC instead is preferred. The fee to use the gasless send method is $40 and it subtracted from the amount being sent. A price oracle will automatically deduct the correct amount of BUCC that corresponds to $40 worth at the time of the transaction.
        </Description> */}
        </Row>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={4} md={3}>
            <InputTitle>{`${t("AmountETHToSpend")}:`}</InputTitle>
          </Grid>
          <Grid item xs={12} sm={8} md={9}>
            <UnderLineTextField
              placeholder="0.00"
              value={amount}
              onChange={onChangeAmount}
            ></UnderLineTextField>
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={4} md={3}>
            <InputTitle>{`${t("AmountBV3AToReceive")}:`}</InputTitle>
          </Grid>
          <Grid item xs={12} sm={8} md={9}>
            <UnderLineTextField
              placeholder="0x000000000000"
              value={address}
              onChange={onChangeAddress}
            ></UnderLineTextField>
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={4} md={3}>
            <InputTitle>{`${t("Salt")}:`}</InputTitle>
          </Grid>
          <Grid item xs={12} sm={8} md={9}>
            <UnderLineTextField
              placeholder="1000000000000"
              value={salt}
              maxLength={13}
              onChange={onChangeSalt}
            ></UnderLineTextField>
          </Grid>
        </Grid>
        <Grid container spacing={2}>
          <Grid item xs={6} md={6}>
            <OutlineButton disabled onClick={(e: any) => console.log}>
              {t("GaslessTransaction")}
            </OutlineButton>
          </Grid>
          <Grid item xs={6} md={6}>
            <OutlineButton onClick={(e) => console.log}>
              {t("StandardTransaction")}
            </OutlineButton>
          </Grid>
        </Grid>
      </SBannerWrapper>
    </div>
  );
};

export default SaleInfo;
